import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromAlertGroup from '../_reducers/alertGroup';

export const selectAlertGroupState =
  createFeatureSelector<fromAlertGroup.AlertGroupState>('alertGroups');

export const selectAllAlertGroups = createSelector(selectAlertGroupState, fromAlertGroup.selectAll);

export const selectAlertGroupEntities = createSelector(
  selectAlertGroupState,
  fromAlertGroup.selectEntities
);

export const selectAlertGroupById = (id: number) =>
  createSelector(selectAlertGroupEntities, (entities) => entities[id]);

export const selectAlertGroupTotal = createSelector(
  selectAlertGroupState,
  fromAlertGroup.selectTotal
);
